import { useState, useLayoutEffect } from "react";
//import debounce from "lodash/debounce";

export default function useDevice(
  breakpoints = { tablet: 768, desktop: 1024 }
) {
  const [isMobile, setMobile] = useState(
    window.innerWidth < breakpoints.tablet
  );
  const [isTablet, setTablet] = useState(
    window.innerWidth >= breakpoints.tablet &&
      window.innerWidth < breakpoints.desktop
  );
  const [isDesktop, setDesktop] = useState(
    window.innerWidth >= breakpoints.desktop
  );

  useLayoutEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < breakpoints.tablet);
      setTablet(
        window.innerWidth >= breakpoints.tablet &&
          window.innerWidth < breakpoints.desktop
      );
      setDesktop(window.innerWidth >= breakpoints.desktop);
    };

    //const debounced = debounce(handleResize, 100);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoints]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isTouchDevice: window.matchMedia("(pointer: coarse)").matches,
  };
}
